import '../css/FlaFramework.css';
import 'animate.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../css/App.css';
import { scroller } from "react-scroll";
import { Link } from "react-router-dom";
import '../css/navbar.css';
import AOS from 'aos';
import 'aos/dist/aos.css';



import bg1 from '../assets/bg1.jpg';
import ico from '../assets/favicon.png';
import chamada2 from '../assets/chamada-2.jpg';
import chamada3 from '../assets/chamada-3.jpg';
import finalbg from '../assets/finalbg.jpg';


import Header from '../templates/header';
import Footer from '../templates/footer';

import { BsDiscord, BsShieldFillCheck } from 'react-icons/bs';
import { AiOutlineEdit } from 'react-icons/ai';
import { FaCodepen, FaSlideshare, FaUserAlt } from 'react-icons/fa';
import { ImUsers } from 'react-icons/im';
import { GiAxeInLog, GiBowman, GiGears } from 'react-icons/gi';
import Swal from 'sweetalert2';
import { Helmet } from 'react-helmet';

export default function homeChamada() {

    const corPrincipal = '#dc494c';
    AOS.init();

    const scrollTo = (where) => {
        scroller.scrollTo(where, {
            duration: 800,
            delay: 0,
            smooth: "easeInOutQuart",
        });
    }

    const mensagem = (a = null) => {
        if (a !== null) {
            a.preventDefault();
        }
        Swal.fire({ title: 'Quase lá !', html: '<p>Relaxa, você não fez nada de errado.</p><br/><p>Acontece que o site ainda não está pronto. Estamos desenvolvendo ele dia após dia. Oque você vê aqui é apenas uma demostração visual de como a página principal do site ficará. Logo botões e as demais ações estão desabilitadas.</p>', icon: 'info' }).then(() => {
            Swal.fire({ title: 'Fique por dentro :)', html: "<p>Em nossas redes sociais você saberá certinho como está sendo todo o processo de desenvolvimento do seu Bar preferido (Taldo's Bar) com videos e etc.</p><br /><p>Eai, vem ficar pertinho da gente !!! </p><a style='color:blue;text-decoration:underline' href='" + window.location.origin + "'>Clique aqui</a>", icon: 'info' })
        })
    }

    return (
        <div>
            <div style={{ backgroundImage: `url(${ico})` }} className='ico-mobile' ></div>
            <div style={{ backgroundImage: `url(${bg1})` }} className='bg1'>
                <Helmet>
                    <title>Taldo's Bar - Site</title>
                    <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9112725996861769" crossorigin="anonymous"></script>
                </Helmet>
                <Header />
                <div className='chamada-1'>

                    <div className='chamada-1-text animate__animated animate__zoomInDown'>
                        <h2>Venha jogar seu RPG conosco !</h2>
                        <p>Traga seu grupo, faça novos amigos em nossa comunidade, <br /> crie mapas, fichas, utilize músicas, token, <br /> importe seus próprios mapas ou crie utilizando nosso criador</p>
                        <p>Totalmente de Graça !</p>
                    </div>

                    <div className='chamada-1-boxs'>
                        <div style={{ borderColor: corPrincipal }} className='chamada-1-box-single animate__animated'>
                            <div><AiOutlineEdit size={60} /></div>
                            <div><p>Personalize seus mapas e fichas <br /> O seu limite é a sua imaginação</p></div>
                        </div>
                        <div style={{ borderColor: corPrincipal }} className='chamada-1-box-single animate__animated'>
                            <div><FaSlideshare size={60} /></div>
                            <div><p>Participe de nossa comunidade <br /> Entre em RPG'S ou crie um e jogue com novas pessoas</p></div>
                        </div>
                        <div style={{ borderColor: corPrincipal }} className='chamada-1-box-single animate__animated'>
                            <div><ImUsers size={60} /></div>
                            <div><p>Com total liberdade você será o que quiser, seja mestre ou player</p></div>
                        </div>
                        <div style={{ borderColor: corPrincipal }} className='chamada-1-box-single animate__animated'>
                            <div><FaCodepen size={60} /></div>
                            <div><p>Site feito com as melhores tecnologias do mercado, para assim melhorar a sua experiência</p></div>
                        </div>
                    </div>
                    <div className='chamada-1-boxs chamada-1-mobile'>
                        <div className='chamada-1-box-single animate__animated'>
                            <div><BsDiscord size={60} /></div>
                            <div><p>Participe da nossa comunidade</p></div>
                        </div>
                        <div className='chamada-1-box-single animate__animated'>
                            <div><GiAxeInLog size={60} /></div>
                            <div><p>Personalize seus mapas e personagens</p></div>
                        </div>
                        <div className='chamada-1-box-single animate__animated'>
                            <div><GiBowman size={60} /></div>
                            <div><p>O limite é a sua imaginação. <br /><br /> Venha Jogar conosco !</p></div>
                        </div>
                        <div className='chamada-1-box-single animate__animated'>
                            <div><a onClick={(a) => mensagem(a)} href="" style={{ borderColor: corPrincipal, fontSize: 25 }} className='button'>Registre-se</a></div>
                        </div>
                    </div>
                    <div className='end-chamada-1 animate__animated' style={{ textAlign: 'center' }}>
                        <p>Não perca tempo e faça parte você também <br /> dessa comunidade !</p>
                        <Link onClick={(a) => mensagem(a)} to=""><a style={{ borderColor: corPrincipal, fontSize: 25 }} className='button'>Registre-se</a></Link>
                    </div>
                </div>
            </div>


            <section className='container section-chamada-2'>
                <div data-aos="fade-right" className='h2-chamada-2'><h2 style={{ borderColor: corPrincipal }}>O que trazemos de novo ?</h2></div>
                <div className='infos-container'>

                    <div className='img-infos'><div data-aos="zoom-in" style={{ backgroundImage: `url(${chamada2})` }} className='img-chamada-2'></div></div>
                    <div className='infos-text'>

                        <div data-aos="fade-up-left" className='info-text-single'>
                            <div className='ico-info-text-single'><BsShieldFillCheck /></div>
                            <div className='info-text-single-text'>
                                <h2>Proteção total</h2>
                                <p>Com a melhor tecnologia disponível no mercado, <br /> trabalhamos constatemente promovendo assim <br /> proteção total aos seus dados</p>
                            </div>
                        </div>

                        <div data-aos="fade-up-left" className='info-text-single'>
                            <div className='ico-info-text-single'><GiGears /></div>
                            <div className='info-text-single-text'>
                                <h2>Personalização</h2>
                                <p>Trazemos inúmeros tipos de personalizações para <br /> você desde a área do cliente, a própria coloração <br /> do site</p>
                            </div>
                        </div>

                        <div data-aos="fade-up-left" className='info-text-single'>
                            <div className='ico-info-text-single'><BsDiscord /></div>
                            <div className='info-text-single-text'>
                                <h2>Integração</h2>
                                <p>Trazemos para você inúmeras formas de participar da comunidade e interagir dentro da área do cliente, desde integração com as notificações do Discord a suas próprias playlists do Spotify</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section name="players" className='container funcoes-section'>
                <div className='division-funcoes'>
                    <div data-aos="flip-left" className='funcoes-single'>
                        <h2 style={{ borderColor: corPrincipal }} className='title-funcoes'>Funções para Players</h2>
                        <p>Trazemos inovações para a configuração e montagem de fichas, totalmente personalizavéis desde cores para o fundo, até a utilização da foto do Discord</p>
                        <p>Notificações na área de login são a implementação mais recente dessa atual versão, além disso possui liberdade para escrever na área destinada aos pensamentos do seu personagem, tais como um bloco de notas.</p>
                        <p>Algumas outras funções particulares são a possibilidade de enviar mensagens privadas aos outros jogadores</p>
                    </div>
                    <div data-aos="fade-up" style={{ backgroundColor: corPrincipal }} className='line-vertical'></div>
                    <div name="mestres" data-aos="flip-right" className='funcoes-single'>
                        <h2 style={{ borderColor: corPrincipal }} className='title-funcoes'>Funções para Mestres</h2>
                        <p>Aos mestres destinamos funções particulares, tais como as opções de importarem músicas para a sessão e modifica-lás através do player disponível no painel do mestre</p>
                        <p>Poderá criar seus próprios mapas através do nosso criador de mapas, ou mesmo importar um mapa pronto.</p>
                        <p>Tokens para os players ou inimigos também podem ser importados para maior comodidade dos mestres</p>
                        <p>Além da criação de suas próprias perícias e atributos</p>
                    </div>
                </div>
            </section>

            <section className='container funcoes-section'>
                <div className='division-funcoes sobre-flex'>
                    <div data-aos="zoom-in" className='funcoes-single single-sobre'>
                        <h2 style={{ borderColor: corPrincipal }} className='title-funcoes'>Sobre nós:</h2>
                        <p>A nossa equipe começou como um pequeno e excêntrico grupo de RPG, buscando uma forma simples e prática de utilizar tudo que sabiamos para aperfeiçoar cada ponto para uma experiência imersiva.</p>
                        <div style={{ backgroundColor: corPrincipal }} className="traco"></div>
                        <p>E é aí que o nosso site entra, buscamos trazer e juntar de forma mais simples e prática para desde um mestre iniciante, ao mais avançado, utilizar todas as nossas ferramentas, tais como uma função de fazer mapas, importar arquivos, utilizar players de música, integração com o discord, dentre outras funcionabilidades, aproveitando e acima de tudo se divertindo o máximo possível !</p>
                    </div>
                    <div className='img-infos-3'><div data-aos="zoom-in" style={{ backgroundImage: `url(${chamada3})` }} className='img-chamada-3'></div></div>
                </div>
            </section>

            <section className='container sobre-donos-section'>
                <div data-aos="fade-up" className='margin-more'>
                    <Slider dots={false} arrows={true} autoplay={true} autoplaySpeed={6000} infinite={true} speed={1000} slidesToShow={1} slidesToScroll={1} >
                        <div className='sobre-single'>
                            <div><FaUserAlt size={35} /></div>
                            <h2>Kaio G</h2>
                            <h3>Coordenador e Dono</h3>
                            <div style={{ backgroundColor: corPrincipal }} className='linha-owner'></div>
                            <p>"Creio eu que este seja o projeto mais gratificante da minha vida, em que eu faço noção só o que eu gosto, mas como faço outras pessoas terem a oportunidade de ver o mundo como eu também vejo"</p>
                        </div>
                        <div className='sobre-single'>
                            <div><FaUserAlt size={35} /></div>
                            <h2>Flaviano</h2>
                            <h3>Full-Stack Developer e Dono</h3>
                            <div style={{ backgroundColor: corPrincipal }} className='linha-owner'></div>
                            <p>"O Taldo's Bar é uma filosofia de vida. Está sendo uma experiência incrível desenvolver este bar tão querido."</p>
                        </div>
                    </Slider>
                </div>
            </section>

            <section style={{ backgroundImage: `url(${finalbg})` }} className='finalbg'>
                <div className='cover-finalbg'>
                    <div className='container container-finalbg'>
                        <h2 data-aos="zoom-in-up" style={{ borderColor: corPrincipal }} className='title-funcoes'>Últimas atualizações:</h2>
                        <div data-aos="zoom-out" style={{ borderColor: corPrincipal }} className='box-atualizacao flex-center'>
                            <p style={{ color: 'white' }}>Estamos Preparando um video top para por aqui :)</p>
                        </div>
                        <p data-aos="flip-down">Para as próximas atualizações fique ligado no nosso <a href="https://discord.gg/acMgWMDeBC" target="_blank" style={{ color: '#7289DA', textDecoration: 'underline' }}>discord</a>, e em nosso <a href="https://twitter.com/taldosbars_ofc" target="_blank" style={{ color: '#1DA1F2', textDecoration: 'underline' }}>Twitter</a> !</p>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    )
}